import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Toast } from 'primeng/toast';
import { PrimeNG } from 'primeng/config';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
  selector: 'rb-root',
  imports: [RouterOutlet, Toast, ConfirmDialog],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'rb-front';

  constructor(
    private config: PrimeNG,
    private translate: TranslateService
  ) {
    this.translate.addLangs(['sr']);
    this.translate.setDefaultLang('sr');
    this.translate.use('sr');
    this.config.setTranslation({ ...this.translate.instant('primeng'), firstDayOfWeek: 1 });
  }
}
